import { render } from "./CategoryWishCourse.vue?vue&type=template&id=55386d15&ts=true"
import script from "./CategoryWishCourse.vue?vue&type=script&lang=ts"
export * from "./CategoryWishCourse.vue?vue&type=script&lang=ts"

import "./CategoryWishCourse.vue?vue&type=style&index=0&id=55386d15&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__